import { init, FeatureFlag } from '@goldcast/feature-flags';
import logger from '@goldcast/logger';

import store from '@/store';
import { getEnv } from '@/utils/env';

export const handleUseJotFormIntegrationChange = (value: boolean) => {
  logger.info('[featureFlag] use_JotForm_Integration changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    useJotFormIntegration: value
  });
};

export const handleDisableCrossEventDashboard = (value: boolean) => {
  logger.info('[featureFlag] disableCrossEventDashboard changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    disableCrossEventDashboard: value
  });
};

export const handleDisableROIDashboard = (value: boolean) => {
  logger.info('[featureFlag] disableROIDashboard changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    disableROIDashboard: value
  });
};

export const handleGoogleAnalyticsEnabledChange = (value: boolean) => {
  logger.info('[featureFlag] googleAnalytics changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    enableGoogleAnalytics: value
  });
};

export const handleUseLogrocketTrackChange = (value: boolean) => {
  logger.info('[featureFlag] Use_Logrocket_Track changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    useLogrocketTrack: value
  });
};

export const handleUseWebinarEventsChange = (value: boolean) => {
  logger.info('[featureFlag] Webinar_Events changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    useWebinarEvents: value
  });
};

export const handleUsePPTAnimationsChange = (value: boolean) => {
  logger.info('[featureFlag] Use_PPT_Animations changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    usePPTAnimations: value
  });
};

export const handleNoTierCustomReportingChange = (value: boolean) => {
  logger.info('[featureFlag] noTierCustomReporting changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    noTierCustomReporting: value
  });
};

export const handleUseSlackChannelVerifyChange = (value: boolean) => {
  logger.info('[featureFlag] useSlackChannelVerify changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    useSlackChannelVerify: value
  });
};

export const handleNotUseRegistrantsCount = (value: boolean) => {
  logger.info('[featureFlag] Not_use_Registrant_Counts changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    notUseRegistrantsCount: value
  });
};

export const handleUseRevenueHero = (value: boolean) => {
  logger.info('[featureFlag] Use_RevenueHero changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    Use_RevenueHero: value
  });
};

export const handleUseWebinarAIIntegration = (value: boolean) => {
  logger.info('[featureFlag] Use_Webinar_AI_Integration changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    useWebinarAIIntegration: value
  });
};

export const handleAssignQnAToSpeakerChange = (value: boolean) => {
  logger.info('[featureFlag] Assign_QnA_To_Speaker changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    assignQnaToSpeaker: value
  });
};

export const handleIsRecordingStudioPricingEnabledChange = (value: boolean) => {
  logger.info('[featureFlag] Use_Recording_Studio_Pricing changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    isRecordingStudioPricingEnabled: value
  });
};

export const handleUseVideoLibraryTranscriptDownload = (value: boolean) => {
  logger.info('[featureFlag] Use_Video_Library_Transcript_Download changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    showVideoLibraryTranscriptDownload: value
  });
};

export const handleUseVideoLibraryClipPublish = (value: boolean) => {
  logger.info('[featureFlag] Use_Video_Library_Clip_Publish changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    showVideoLibraryClipPublish: value
  });
};

export const handleUseOneClickRegister = (value: boolean) => {
  logger.info('[featureFlag] One_Click_Register changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    isOneClickRegisterEnabled: value
  });
};

export const handleUseHLSGuard = (value: boolean) => {
  logger.info('[featureFlag] Use_HLS_Guard changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    useHLSGuard: value
  });
};

export const handleUseClTestRsDate = value => {
  logger.info('[featureFlag] Use_CL_Test_RS_Date changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    clRecordingSupportStartDate: value
  });
};
export const handleUseCLUploadsInVL = (value: boolean) => {
  logger.info('[featureFlag] Use_CL_Uploads_In_VL changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    Use_CL_Uploads_In_VL: value
  });
};

export const handleUseCLClipDuplication = (value: boolean) => {
  logger.info('[featureFlag] Use_CL_Clip_Duplication changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    Use_CL_Clip_Duplication: value
  });
};

export const handleUseOmniEmbed = (value: boolean) => {
  logger.info('[featureFlag] Use_Omni_Embed changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    useOmniEmbed: value
  });
};

export const handleUseCLEUProcessing = (value: boolean) => {
  logger.info('[featureFlag] Use_CL_EU_Processing changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    Use_CL_EU_Processing: value
  });
};

export const handleUseEventLocaleForDateTimeFormattingChange = (value: boolean) => {
  logger.info('[featureFlag] useEventLocaleForDateTimeFormatting changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    useEventLocaleForDateTimeFormatting: value
  });
};

export const handleUseCustomRoles = (value: boolean) => {
  logger.info('[featureFlag] Use_Custom_Roles changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    isCustomRolesEnabled: value
  });
};

export const handleEnableDuplicateEventViaWorkflow = (value: boolean) => {
  logger.info('[featureFlag] enableDuplicateEventViaWorkflow changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    enableDuplicateEventViaWorkflow: value
  });
};

export const handleUseAIPageRevamp = (value: boolean) => {
  logger.info('[featureFlag] useAIPageRevamp changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    useAIPageRevamp: value
  });
};

export const handleUse1080VideoQuality = (value: boolean) => {
  logger.info('[featureFlag] USE_1080_VIDEO_QUALITY changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    use1080VideoQuality: value
  });
};

export const handleEnableAIInsightReport = (value: boolean) => {
  logger.info('[featureFlag] enableAIInsightReport changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    enableAIInsightReport: value
  });
};

export const handleGlobalSSO = (value: boolean) => {
  logger.info('[featureFlag] GlobalSSO changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    enableGlobalSSO: value
  });
};

export const handleUseCustomRolesManageUsersUIv2 = (value: boolean) => {
  logger.info('[featureFlag] Use_Custom_Roles_Manage_Users_UI_v2 changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    useCustomRolesManageUsersUIv2: value
  });
};

export const handleUseNewChatApp = (value: boolean) => {
  logger.info('[featureFlag] USE_NEW_CHAT_APP changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    useNewChatApp: value
  });
};

export const handleIsAiSummaryGenerationEnabled = (value: boolean) => {
  logger.info('[featureFlag] is_ai_summary_generation_enabled changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    isAiSummaryGenerationEnabled: value
  });
};

export const handleUseNewNameCard = (value: boolean) => {
  logger.info('[featureFlag] Use_New_Name_Card changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    useNewNameCard: value
  });
};

export const handleCancelCalendarInviteOnDelete = (value: boolean) => {
  logger.info('cancel_calendar_invite_on_delete changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    enableCancelCalendarInviteOnDelete: value
  });
};

export const handleUseSalesforceCampaignCreationCustomSolution = (value: boolean) => {
  logger.info('[featureFlag] Use_Salesforce_Campaign_Creation_Custom_Solution changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    useSalesforceCampaignCreationCustomSolution: value
  });
};

export const handleUseRSAlignedFeeds = (value: boolean) => {
  logger.info('[featureFlag] Use_RS_Aligned_Feeds changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    useRSAlignedFeeds: value
  });
};

export const handleEnableSyncPreferenceForActivities = (value: boolean) => {
  logger.info('[featureFlag] enableSyncPreferenceForActivities changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    enableSyncPreferenceForActivities: value
  });
};

export const handleEnablePushSpeakerToStage = (value: boolean) => {
  logger.info('[featureFlag] Enable_Push_Speaker_To_Stage changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    enablePushSpeakerToStage: value
  });
};

export const handleUseRSAlignedFeedsDate = value => {
  logger.info('[featureFlag] Use_RS_Aligned_Feeds_Date changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    useRSAlignedFeedsDate: value
  });
};
export const handleUseTwoStepCTA = (value: boolean) => {
  logger.info('[featureFlag] Use_Two_Step_CTA changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    useTwoStepCTA: value
  });
};

export const handleUseInHouseIntegrationAuth = (value: boolean) => {
  logger.info('[featureFlag] UseInHouseIntegrationAuth changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    UseInHouseIntegrationAuth: value
  });
};

export const handleEnableStudioMagiclinkInvalidation = (value: boolean) => {
  logger.info('[featureFlag] enable_studio_magiclink_invalidation changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    enableStudioMagiclinkInvalidation: value
  });
};

export const handleEnableMagicLinkTtl = (value: boolean) => {
  logger.info('[featureFlag] enable_magic_link_ttl changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    enable_magic_link_ttl: value
  });
};

export const handleEnableIgnoreS3Upload = (value: boolean) => {
  logger.info('[featureFlag] enable_ignore_s3_upload changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    enable_ignore_s3_upload: value
  });
};

export const handleUseNewSlideAnimationsChange = (value: boolean) => {
  logger.info('[featureFlag] USE_NEW_SLIDE_ANIMATION changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    useNewSlideAnimations: value
  });
};

export const handleUseFloatingEmoji = (value: boolean) => {
  logger.info('[featureFlag] Use_Floating_Emoji changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    useFloatingEmoji: value
  });
};

export const handleUseClPlatformBrandkit = (value: boolean) => {
  logger.info('[featureFlag] Use_CL_Platform_Brandkit changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    useCLPlatformBrandkit: value
  });
};

export const handleEnableEventInternalName = (value: boolean) => {
  logger.info('[featureFlag] Enable_Event_Internal_Name changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    enableEventInternalName: value
  });
};

export const handleHideRegistrantCountWhenZero = (value: boolean) => {
  logger.info('[featureFlag] hideRegistrantCountWhenZero changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    hideRegistrantCountWhenZero: value
  });
};

export const handleEnableCertificates = (value: boolean) => {
  logger.info('[featureFlag] Enable_Certificates changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    enableCertificateBuilder: value
  });
};

export const handleEnableCertificateProfessionalEducation = (value: boolean) => {
  logger.info('[featureFlag] enableCertificateProfessionalEducation changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    enableCertificateProfessionalEducation: value
  });
};

export const handleSalesforceCampaignCloneInTemplate = (value: boolean) => {
  logger.info('[featureFlag] salesforce_campaign_clone_in_template changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    salesforceCampaignCloneInTemplate: value
  });
};

export const handleUseCatchMeUp = (value: boolean) => {
  logger.info('[featureFlag] Use_Catch_Me_Up changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    useCatchMeUp: value
  });
};

export const handleReplaceBeeProChange = (value: boolean): void => {
  logger.info('[featureFlag] Replace_BeePro changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    replaceBeeProEnabled: value
  });
};

export const handleMaxBulkUploadRecords = (value: number): void => {
  logger.info('[featureFlag] max_bulk_upload_records changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    maxBulkUploadRecords: value
  });
};

export const handleUseOnDemandMQL = (value: boolean): void => {
  logger.info('[featureFlag] Use_OnDemand_MQL changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    useOnDemandMQL: value
  });
};

export const handleUseCLSimplifiedUpload = (value: boolean): void => {
  logger.info('[featureFlag] Use_CL_Simplified_Upload changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    Use_CL_Simplified_Upload: value
  });
};

export const handleUseSalesforceChatInProduct = (value: boolean): void => {
  logger.info('[featureFlag] useSalesforceChatInProduct changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    useSalesforceChatInProduct: value
  });
};

export const handleGdprTrackingConsentEnabled = (value: boolean): void => {
  logger.info('[featureFlag] gdpr_tracking_consent_enabled changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    gdprTrackingConsentEnabled: value
  });
};

export const handleEnableSeriesOnDemandBulkRegistration = (value: boolean): void => {
  logger.info('[featureFlag] enable_series_ondemand_bulk_registration changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    enableSeriesOnDemandBulkRegistration: value
  });
};

export const handleUseBackendTray = (value: boolean): void => {
  logger.info('[featureFlag] Use_Backend_Tray changed to', value);
  store.commit('org/setCurrentOrg', {
    ...store.getters['org/getCurrentOrg'],
    useBackendTray: value
  });
};

/* eslint-disable no-unused-vars */
export enum FeatureFlagKeys {
  use_JotForm_Integration = 'use_JotForm_Integration',
  disableCrossEventDashboard = 'disableCrossEventDashboard',
  disableROIDashboard = 'disableROIDashboard',
  enableGoogleAnalytics = 'google_analytics',
  Use_Logrocket_Track = 'Use_Logrocket_Track',
  Webinar_Events = 'Webinar_Events',
  Use_PPT_Animations = 'Use_PPT_Animations',
  noTierCustomReporting = 'noTierCustomReporting',
  useSlackChannelVerify = 'useSlackChannelVerify',
  Not_use_Registrant_Counts = 'Not_use_Registrant_Counts',
  Use_RevenueHero = 'Use_RevenueHero',
  Use_Webinar_AI_Integration = 'Use_Webinar_AI_Integration',
  Assign_To_Speaker = 'Assign_To_Speaker',
  Use_Video_Library_Transcript_Download = 'Use_Video_Library_Transcript_Download',
  Use_Video_Library_Clip_Publish = 'Use_Video_Library_Clip_Publish',
  One_Click_Register = 'One_Click_Register',
  Use_Recording_Studio_Pricing = 'Use_Recording_Studio_Pricing',
  Use_Hls_Guard = 'Use_Hls_Guard',
  Use_CL_Test_RS_Date = 'Use_CL_Test_RS_Date',
  Use_CL_Uploads_In_VL = 'Use_CL_Uploads_In_VL',
  Use_CL_EU_Processing = 'Use_CL_EU_Processing',
  useEventLocaleForDateTimeFormatting = 'useEventLocaleForDateTimeFormatting',
  Use_Custom_Roles = 'Use_Custom_Roles',
  enableDuplicateEventViaWorkflow = 'enableDuplicateEventViaWorkflow',
  useAIPageRevamp = 'useAIPageRevamp',
  USE_1080_VIDEO_QUALITY = 'USE_1080_VIDEO_QUALITY',
  enableAIInsightReport = 'enableAIInsightReport',
  GlobalSSO = 'GlobalSSO',
  Use_Custom_Roles_Manage_Users_UI_v2 = 'Use_Custom_Roles_Manage_Users_UI_v2',
  USE_NEW_CHAT_APP = 'USE_NEW_CHAT_APP',
  is_ai_summary_generation_enabled = 'is_ai_summary_generation_enabled',
  Use_New_Name_Card = 'Use_New_Name_Card',
  Use_Salesforce_Campaign_Creation_Custom_Solution = 'Use_Salesforce_Campaign_Creation_Custom_Solution',
  Use_RS_Aligned_Feeds = 'Use_RS_Aligned_Feeds',
  enableSyncPreferenceForActivities = 'enableSyncPreferenceForActivities',
  Enable_Push_Speaker_To_Stage = 'Enable_Push_Speaker_To_Stage',
  Use_RS_Aligned_Feeds_Date = 'Use_RS_Aligned_Feeds_Date',
  Use_Two_Step_CTA = 'Use_Two_Step_CTA',
  UseInHouseIntegrationAuth = 'UseInHouseIntegrationAuth',

  enable_studio_magiclink_invalidation = 'enable_studio_magiclink_invalidation',
  enable_magic_link_ttl = 'enable_magic_link_ttl',
  enable_ignore_s3_upload = 'enable_ignore_s3_upload',

  USE_NEW_SLIDE_ANIMATION = 'USE_NEW_SLIDE_ANIMATION',
  Use_Floating_Emoji = 'Use_Floating_Emoji',
  Use_CL_Platform_Brandkit = 'Use_CL_Platform_Brandkit',
  Enable_Event_Internal_Name = 'Enable_Event_Internal_Name',
  CancelCalendarInviteOnDelete = 'cancel_calendar_invite_on_delete',
  hideRegistrantCountWhenZero = 'hideRegistrantCountWhenZero',
  enableCertificateBuilder = 'enableCertificateBuilder',
  enableCertificateProfessionalEducation = 'enableCertificateProfessionalEducation',
  salesforce_campaign_clone_in_template = 'salesforce_campaign_clone_in_template',
  Use_Catch_Me_Up = 'Use_Catch_Me_Up',
  Replace_BeePro = 'Replace_BeePro',
  max_bulk_upload_records = 'max_bulk_upload_records',
  Use_OnDemand_MQL = 'Use_OnDemand_MQL',
  Use_CL_Simplified_Upload = 'Use_CL_Simplified_Upload',
  useSalesforceChatInProduct = 'useSalesforceChatInProduct',
  gdpr_tracking_consent_enabled = 'gdpr_tracking_consent_enabled',
  Use_CL_Clip_Duplication = 'Use_CL_Clip_Duplication',
  Use_Omni_Embed = 'Use_Omni_Embed',
  enable_series_ondemand_bulk_registration = 'enable_series_ondemand_bulk_registration',
  Use_Backend_Tray = 'Use_Backend_Tray'
}

type FeatureFlags = {
  [K in FeatureFlagKeys]: K extends FeatureFlagKeys.max_bulk_upload_records
    ? FeatureFlag<number>
    : FeatureFlag<boolean>;
};
/* eslint-enable no-unused-vars */

export const featureFlags = (): FeatureFlags => ({
  [FeatureFlagKeys.use_JotForm_Integration]: {
    value: false,
    changeHandler: handleUseJotFormIntegrationChange
  },
  [FeatureFlagKeys.disableCrossEventDashboard]: {
    value: false,
    changeHandler: handleDisableCrossEventDashboard
  },
  [FeatureFlagKeys.disableROIDashboard]: {
    value: false,
    changeHandler: handleDisableROIDashboard
  },
  [FeatureFlagKeys.enableGoogleAnalytics]: {
    value: false,
    changeHandler: handleGoogleAnalyticsEnabledChange
  },
  [FeatureFlagKeys.Use_Logrocket_Track]: {
    value: false,
    changeHandler: handleUseLogrocketTrackChange
  },
  [FeatureFlagKeys.Webinar_Events]: {
    value: false,
    changeHandler: handleUseWebinarEventsChange
  },
  [FeatureFlagKeys.Use_PPT_Animations]: {
    value: false,
    changeHandler: handleUsePPTAnimationsChange
  },
  [FeatureFlagKeys.noTierCustomReporting]: {
    value: false,
    changeHandler: handleNoTierCustomReportingChange
  },
  [FeatureFlagKeys.useSlackChannelVerify]: {
    value: false,
    changeHandler: handleUseSlackChannelVerifyChange
  },
  [FeatureFlagKeys.Not_use_Registrant_Counts]: {
    value: false,
    changeHandler: handleNotUseRegistrantsCount
  },
  [FeatureFlagKeys.Use_RevenueHero]: {
    value: false,
    changeHandler: handleUseRevenueHero
  },
  [FeatureFlagKeys.Use_Webinar_AI_Integration]: {
    value: false,
    changeHandler: handleUseWebinarAIIntegration
  },
  [FeatureFlagKeys.Assign_To_Speaker]: {
    value: false,
    changeHandler: handleAssignQnAToSpeakerChange
  },
  [FeatureFlagKeys.Use_Video_Library_Transcript_Download]: {
    value: false,
    changeHandler: handleUseVideoLibraryTranscriptDownload
  },
  [FeatureFlagKeys.Use_Video_Library_Clip_Publish]: {
    value: false,
    changeHandler: handleUseVideoLibraryClipPublish
  },
  [FeatureFlagKeys.One_Click_Register]: {
    value: false,
    changeHandler: handleUseOneClickRegister
  },
  [FeatureFlagKeys.Use_Recording_Studio_Pricing]: {
    value: false,
    changeHandler: handleIsRecordingStudioPricingEnabledChange
  },
  [FeatureFlagKeys.Use_Hls_Guard]: {
    value: false,
    changeHandler: handleUseHLSGuard
  },
  [FeatureFlagKeys.Use_CL_Test_RS_Date]: {
    // TODO @dusangc GS-22328: Add correct string value for multi-variant FF
    value: null as any,
    changeHandler: handleUseClTestRsDate
  },
  [FeatureFlagKeys.Use_CL_Uploads_In_VL]: {
    value: false,
    changeHandler: handleUseCLUploadsInVL
  },
  [FeatureFlagKeys.Use_CL_EU_Processing]: {
    value: false,
    changeHandler: handleUseCLEUProcessing
  },
  [FeatureFlagKeys.useEventLocaleForDateTimeFormatting]: {
    value: false,
    changeHandler: handleUseEventLocaleForDateTimeFormattingChange
  },
  [FeatureFlagKeys.Use_Custom_Roles]: {
    value: false,
    changeHandler: handleUseCustomRoles
  },
  [FeatureFlagKeys.enableDuplicateEventViaWorkflow]: {
    value: false,
    changeHandler: handleEnableDuplicateEventViaWorkflow
  },
  [FeatureFlagKeys.useAIPageRevamp]: {
    value: false,
    changeHandler: handleUseAIPageRevamp
  },
  [FeatureFlagKeys.USE_1080_VIDEO_QUALITY]: {
    value: false,
    changeHandler: handleUse1080VideoQuality
  },
  [FeatureFlagKeys.enableAIInsightReport]: {
    value: false,
    changeHandler: handleEnableAIInsightReport
  },
  [FeatureFlagKeys.GlobalSSO]: {
    value: false,
    changeHandler: handleGlobalSSO
  },
  [FeatureFlagKeys.Use_Custom_Roles_Manage_Users_UI_v2]: {
    value: false,
    changeHandler: handleUseCustomRolesManageUsersUIv2
  },
  [FeatureFlagKeys.USE_NEW_CHAT_APP]: {
    value: false,
    changeHandler: handleUseNewChatApp
  },
  [FeatureFlagKeys.is_ai_summary_generation_enabled]: {
    value: false,
    changeHandler: handleIsAiSummaryGenerationEnabled
  },
  [FeatureFlagKeys.Use_New_Name_Card]: {
    value: false,
    changeHandler: handleUseNewNameCard
  },
  [FeatureFlagKeys.CancelCalendarInviteOnDelete]: {
    value: false,
    changeHandler: handleCancelCalendarInviteOnDelete
  },
  [FeatureFlagKeys.Use_Salesforce_Campaign_Creation_Custom_Solution]: {
    value: false,
    changeHandler: handleUseSalesforceCampaignCreationCustomSolution
  },
  [FeatureFlagKeys.Use_RS_Aligned_Feeds]: {
    value: false,
    changeHandler: handleUseRSAlignedFeeds
  },
  [FeatureFlagKeys.enableSyncPreferenceForActivities]: {
    value: false,
    changeHandler: handleEnableSyncPreferenceForActivities
  },
  [FeatureFlagKeys.Enable_Push_Speaker_To_Stage]: {
    value: false,
    changeHandler: handleEnablePushSpeakerToStage
  },
  [FeatureFlagKeys.Use_RS_Aligned_Feeds_Date]: {
    value: null as any,
    changeHandler: handleUseRSAlignedFeedsDate
  },
  [FeatureFlagKeys.Use_Two_Step_CTA]: {
    value: false,
    changeHandler: handleUseTwoStepCTA
  },
  [FeatureFlagKeys.UseInHouseIntegrationAuth]: {
    value: false,
    changeHandler: handleUseInHouseIntegrationAuth
  },

  [FeatureFlagKeys.enable_studio_magiclink_invalidation]: {
    value: false,
    changeHandler: handleEnableStudioMagiclinkInvalidation
  },
  [FeatureFlagKeys.enable_magic_link_ttl]: {
    value: false,
    changeHandler: handleEnableMagicLinkTtl
  },
  [FeatureFlagKeys.enable_ignore_s3_upload]: {
    value: false,
    changeHandler: handleEnableIgnoreS3Upload
  },

  [FeatureFlagKeys.USE_NEW_SLIDE_ANIMATION]: {
    value: false,
    changeHandler: handleUseNewSlideAnimationsChange
  },
  [FeatureFlagKeys.Use_Floating_Emoji]: {
    value: false,
    changeHandler: handleUseFloatingEmoji
  },
  [FeatureFlagKeys.Use_CL_Platform_Brandkit]: {
    value: false,
    changeHandler: handleUseClPlatformBrandkit
  },
  [FeatureFlagKeys.Enable_Event_Internal_Name]: {
    value: false,
    changeHandler: handleEnableEventInternalName
  },
  [FeatureFlagKeys.hideRegistrantCountWhenZero]: {
    value: false,
    changeHandler: handleHideRegistrantCountWhenZero
  },
  [FeatureFlagKeys.enableCertificateBuilder]: {
    value: false,
    changeHandler: handleEnableCertificates
  },
  [FeatureFlagKeys.enableCertificateProfessionalEducation]: {
    value: false,
    changeHandler: handleEnableCertificateProfessionalEducation
  },
  [FeatureFlagKeys.salesforce_campaign_clone_in_template]: {
    value: false,
    changeHandler: handleSalesforceCampaignCloneInTemplate
  },
  [FeatureFlagKeys.Use_Catch_Me_Up]: {
    value: false,
    changeHandler: handleUseCatchMeUp
  },
  [FeatureFlagKeys.Replace_BeePro]: {
    value: false,
    changeHandler: handleReplaceBeeProChange
  },
  [FeatureFlagKeys.max_bulk_upload_records]: {
    value: 0,
    changeHandler: handleMaxBulkUploadRecords
  },
  [FeatureFlagKeys.Use_OnDemand_MQL]: {
    value: false,
    changeHandler: handleUseOnDemandMQL
  },
  [FeatureFlagKeys.Use_CL_Simplified_Upload]: {
    value: false,
    changeHandler: handleUseCLSimplifiedUpload
  },
  [FeatureFlagKeys.Use_CL_Clip_Duplication]: {
    value: false,
    changeHandler: handleUseCLClipDuplication
  },
  [FeatureFlagKeys.Use_Omni_Embed]: {
    value: false,
    changeHandler: handleUseOmniEmbed
  },
  [FeatureFlagKeys.useSalesforceChatInProduct]: {
    value: false,
    changeHandler: handleUseSalesforceChatInProduct
  },
  [FeatureFlagKeys.gdpr_tracking_consent_enabled]: {
    value: false,
    changeHandler: handleGdprTrackingConsentEnabled
  },
  [FeatureFlagKeys.enable_series_ondemand_bulk_registration]: {
    value: false,
    changeHandler: handleEnableSeriesOnDemandBulkRegistration
  },
  [FeatureFlagKeys.Use_Backend_Tray]: {
    value: false,
    changeHandler: handleUseBackendTray
  }
});

export const initializeFeatureFlags = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    try {
      init(
        getEnv('VUE_APP_HARNESS_SECRET') || '',
        {
          identifier: store.state.user.currentUser?.id || 'anonymous',
          name: `${store.state.user.currentUser?.first_name} ${store.state.user.currentUser?.last_name}` || 'anonymous',
          attributes: {
            role: 2, // admin role
            event: '',
            eventOrganization: store.getters['org/getCurrentOrg']?.id,
            appHostname: window.location?.hostname,
            org_creation_source: store.getters['org/getCurrentOrg']?.org_creation_source || ''
          }
        },
        featureFlags(),
        {
          ready: flags => {
            window.analytics.track('HarnessFeatureFlagsReady', flags);
            Object.keys(flags).forEach(flagKey => {
              logger.addFeatureFlag(flagKey, String(flags[flagKey]));
            });
            store.commit('org/setIsFeatureFlagLoading', false);
            resolve();
          },
          change: changeInfo => {
            logger.addFeatureFlag(changeInfo.flag, String(changeInfo.value));
          },
          errorAuth: () => {
            store.commit('org/setIsFeatureFlagLoading', false);
            reject(new Error('Harness Feature Flag auth failed'));
          }
        }
      );
    } catch (error: any) {
      store.commit('org/setIsFeatureFlagLoading', false);
      logger.error('[featureFlag] Harness Feature Flag init failed:', error);
      reject(error);
    }
  });
};
